import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type SidebarFooterProps = ComponentProps<'div'>;

const SidebarFooter = ({ className, ...props }: SidebarFooterProps) => {
  return (
    <div
      data-slot="sidebar-footer"
      data-sidebar="footer"
      className={cn('flex flex-col gap-2 p-2', className)}
      {...props}
    />
  );
};

export default SidebarFooter;
